import { Sparkles, HelpCircle, MessageCircleQuestion, Search } from 'lucide-react';
import { SectionPageEditor } from '@/components/admin/SectionPageEditor';
import type { SectionDef, TextFieldDef } from '@/components/admin/SectionPageEditor';

// pages/faq/page.tsx is a single file with a hardcoded groups array (4
// groups × 5/3/3/3 Q&A pairs = 14 pairs, verified against the actual
// array, not just the locale bundle) — generated here instead of
// hand-listing all 28 question/answer keys. faq.groupC.q4.* exists in the
// locale bundle but isn't in the page's groupC.items array — orphaned,
// excluded. No images on this page.
function groupTexts(group: string, count: number): TextFieldDef[] {
  const fields: TextFieldDef[] = [];
  for (let i = 1; i <= count; i++) {
    fields.push({ key: `faq.${group}.q${i}.question`, label: `Q${i} — Question` });
    fields.push({ key: `faq.${group}.q${i}.answer`, label: `Q${i} — Answer`, long: true });
  }
  return fields;
}

const FAQ_SECTIONS: SectionDef[] = [
  {
    key: 'hero',
    title: 'Hero',
    icon: Sparkles,
    texts: [
      { key: 'faq.hero.label', label: 'Eyebrow Label' },
      { key: 'faq.hero.heading', label: 'Heading' },
      { key: 'faq.hero.subtitle', label: 'Subtitle' },
    ],
  },
  {
    key: 'groupA',
    title: 'Group A (5 questions)',
    icon: HelpCircle,
    texts: [{ key: 'faq.groupA.title', label: 'Group Title' }, ...groupTexts('groupA', 5)],
  },
  {
    key: 'groupB',
    title: 'Group B (3 questions)',
    icon: HelpCircle,
    texts: [{ key: 'faq.groupB.title', label: 'Group Title' }, ...groupTexts('groupB', 3)],
  },
  {
    key: 'groupC',
    title: 'Group C (3 questions)',
    icon: HelpCircle,
    texts: [{ key: 'faq.groupC.title', label: 'Group Title' }, ...groupTexts('groupC', 3)],
  },
  {
    key: 'groupD',
    title: 'Group D (3 questions)',
    icon: HelpCircle,
    texts: [{ key: 'faq.groupD.title', label: 'Group Title' }, ...groupTexts('groupD', 3)],
  },
  {
    key: 'bottom',
    title: 'Bottom CTA',
    icon: MessageCircleQuestion,
    texts: [
      { key: 'faq.bottom.title', label: 'Heading' },
      { key: 'faq.bottom.body', label: 'Body Text', long: true },
      { key: 'faq.bottom.cta', label: 'Button' },
    ],
  },
  {
    key: 'seo',
    title: 'SEO',
    icon: Search,
    note: 'Shown in Google search results and social media link previews — not visible on the page itself.',
    texts: [
      { key: 'seo.faq.title', label: 'Meta Title', long: true },
      { key: 'seo.faq.description', label: 'Meta Description', long: true },
    ],
  },
];

export default function AdminFaqPage() {
  return <SectionPageEditor pageKey="faq" title="FAQ" sections={FAQ_SECTIONS} />;
}
